<template>
    <div class="block-editor send-email">
        <div class="wrapper" v-if="reservationPlans.length > 0">
            <div class="title">Select Reservation</div>
            <a-select show-search v-model="clone.reservationPlanId">
                <a-select-option
                    v-for="(reservationPlan, index) of reservationPlans"
                    :key="index"
                    :value="reservationPlan._id"
                >
                    {{ reservationPlan.title }}
                </a-select-option>
            </a-select>
            <a-select v-model="clone.duration" show-search class="duration">
                <a-select-option v-for="(remindDate, index) of remindDates" :key="index" :value="remindDate.value">
                    {{ remindDate.label }}
                </a-select-option>
            </a-select>
        </div>
        <div v-else class="empty-list">Lütfen rezervasyon planı oluşturunuz.</div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";
import { CALENDAR_API } from "../../../../../../api/calendar";

const log = log2("ReservationOpenUrl");
export default {
    name: "ReservationOpenUrl",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            reservationPlans: [],
            remindDates: [
                {
                    value: 5,
                    label: "15 dakika",
                },
                {
                    value: 10,
                    label: "15 dakika",
                },
                {
                    value: 15,
                    label: "15 dakika",
                },
                {
                    value: 30,
                    label: "30 dakika",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({}),
    },
    mounted() {
        CALENDAR_API.getAllReservationList().then((res) => {
            this.reservationPlans = res;
        });
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-email {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0;
            border: 1px solid #fff;
            background: white;
        }

        .form-input {
            margin-top: 10px;

            .form-input-name {
                margin-left: 5px;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
            }
        }
    }

    .duration {
        margin-top: 10px;
    }

    .empty-list {
        text-align: center;
        font-size: 16px;
    }
}
</style>
